/* ============================================================
   SHINE & STYLE — catalogue search

   Searches all 152 products from assets/ss-search-index.json
   rather than filtering whatever happened to be on the page.

   The index is fetched once, on first use, so a visitor who never
   searches never pays for it.
   ============================================================ */
(function () {
  'use strict';

  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  if (!input || !results) return;

  var countOut = document.querySelector('[data-search-count]');
  var emptyBox = document.querySelector('[data-search-empty]');
  var termOut = document.querySelector('[data-search-term]');
  var suggestions = document.querySelector('[data-search-suggestions]');

  // Arabic pages live in ar/, so assets resolve one level up. Product
  // URLs do NOT get the prefix - product-x.html sits beside the Arabic
  // search page, so prefixing it would walk out of the language folder.
  var assetBase = results.getAttribute('data-base') || '';
  var index = null;
  var loading = null;

  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    loading = fetch(assetBase + 'assets/ss-search-index.json')
      .then(function (r) { return r.json(); })
      .then(function (rows) { index = rows; return rows; })
      .catch(function () { index = []; return index; });
    return loading;
  }

  /* Score a row against the query. Title matches outrank tag matches,
     and a match at the start of the title outranks one in the middle,
     so "denim" leads with the denim pieces rather than anything merely
     tagged denim. */
  function score(row, words) {
    var title = row.t.toLowerCase();
    var hay = title + ' ' + row.y.toLowerCase() + ' ' + row.g;
    var total = 0;

    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (hay.indexOf(w) === -1) return 0;          // every word must appear
      if (title.indexOf(w) === 0) total += 10;
      else if (title.indexOf(w) !== -1) total += 6;
      else if (row.y.toLowerCase().indexOf(w) !== -1) total += 3;
      else total += 1;
    }
    return total;
  }

  function money(n) {
    return '$' + n.toFixed(2);
  }

  function render(rows, term) {
    if (termOut) termOut.textContent = term;

    if (!rows.length) {
      results.innerHTML = '';
      results.hidden = true;
      if (emptyBox) emptyBox.hidden = false;
      if (suggestions) suggestions.hidden = false;
      if (countOut) countOut.textContent = '';
      return;
    }

    results.hidden = false;
    if (emptyBox) emptyBox.hidden = true;
    if (suggestions) suggestions.hidden = true;
    if (countOut) {
      var noun = rows.length === 1
        ? (countOut.getAttribute('data-label-one') || 'result')
        : (countOut.getAttribute('data-label') || 'results');
      countOut.textContent = rows.length + ' ' + noun;
    }

    results.innerHTML = rows.map(function (r) {
      return '<article class="ss-card" data-cat="' + r.c + '">' +
        '<div class="ss-card__media">' +
          '<img src="' + assetBase + r.i + '" alt="" loading="lazy">' +
        '</div>' +
        '<p class="ss-card__type">' + r.y + '</p>' +
        '<h3 class="ss-card__title"><a href="' + r.u + '">' + r.t + '</a></h3>' +
        '<p class="ss-card__price">' + money(r.p) + '</p>' +
      '</article>';
    }).join('');
  }

  function run(term) {
    term = term.trim().toLowerCase();

    if (term.length < 2) {
      results.hidden = true;
      results.innerHTML = '';
      if (emptyBox) emptyBox.hidden = true;
      if (suggestions) suggestions.hidden = false;
      if (countOut) countOut.textContent = '';
      return;
    }

    load().then(function (rows) {
      var words = term.split(/\s+/).filter(Boolean);
      var hits = [];

      for (var i = 0; i < rows.length; i++) {
        var s = score(rows[i], words);
        if (s > 0) hits.push({ row: rows[i], s: s });
      }

      hits.sort(function (a, b) { return b.s - a.s || a.row.t.localeCompare(b.row.t); });
      render(hits.slice(0, 60).map(function (h) { return h.row; }), term);
    });
  }

  var timer;
  input.addEventListener('input', function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { run(input.value); }, 130);
  });

  input.addEventListener('focus', load);           // warm the index on focus

  var form = input.closest('form');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); run(input.value); });

  // Quick-pick chips fill the box and search.
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-search-term-set]'),
    function (btn) {
      btn.addEventListener('click', function () {
        input.value = btn.getAttribute('data-search-term-set');
        input.focus();
        run(input.value);
      });
    }
  );

  // A ?q= in the URL runs immediately, so search results are linkable.
  var q = new URLSearchParams(window.location.search).get('q');
  if (q) {
    input.value = q;
    run(q);
  }
})();
